import type { ApiRequest } from '@/types/api';
import type {
    TransferCountByStatus,
    PaymentsRequest,
    CancelPaymentRequest,
    RetryPaymentRequest,
    SendNowPaymentRequest,
    EditPaymentRequest,
    PaymentDetailsRequest,
} from '@/types/api/payments';
import type { ApprovalDecision } from '@/types/models';

export type ApprovePaymentRequest = ApiRequest<
    'PUT',
    `approvals/${string}`,
    [],
    { decision: ApprovalDecision; reason?: string }
>;

type PaymentsApi = {
    countByStatus: TransferCountByStatus['url'];
    list: PaymentsRequest['url'];
    approve(approvalId: string): ApprovePaymentRequest['url'];
    cancel: (id: string) => CancelPaymentRequest['url'];
    retry: (id: string) => RetryPaymentRequest['url'];
    sendNow: (id: string) => SendNowPaymentRequest['url'];
    edit: (id: string) => EditPaymentRequest['url'];
    details: (id: string) => PaymentDetailsRequest['url'];
};

export const paymentsApi: PaymentsApi = {
    countByStatus: 'transfers/count/by-status',
    list: 'transfers',
    approve: (approvalId: string) => `approvals/${approvalId}`,
    cancel: (id: string) => `transfers/${id}/cancel`,
    retry: (id: string) => `transfers/${id}/retry`,
    sendNow: (id: string) => `transfers/${id}/send-now`,
    edit: (id: string) => `transfers/${id}`,
    details: (id: string) => `transfers/${id}`,
};
